export const authProvider = {
  GOOGLE: "google",
  GITHUB: "github",
  LINKED_IN: "linkedin",
  GMAIL_MANUALLY: "email",
  MICROSOFT: "microsoft"
};

export default authProvider;
